export const ESurveyStatuses = {
  ACTIVE: 0,
  PAST: 1,
  PLANNED: 2,
}
